var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333132",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M16.5 30c5.385 0 9.75-4.365 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75S11.115 30 16.5 30Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333132",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M29.138 10.856c.862-.233 1.75-.353 2.643-.356a9.75 9.75 0 1 1 0 19.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M3 37.013a16.5 16.5 0 0 1 27 0M31.781 30a16.48 16.48 0 0 1 13.5 7.013"
})));
export default SvgUsers;